import type { DirectoryMember } from "@/api/queries";

/** "Arasi S Ukani (TSE - 0.03)": the name, then designation and experience as Workspace words them. */
export function memberLabel(m: Pick<DirectoryMember, "full_name" | "member_no" | "designation" | "experience">): string {
  const detail = [m.designation, m.experience].filter(Boolean).join(" - ");
  return `${m.full_name || m.member_no}${detail ? ` (${detail})` : ""}`;
}

/** "APM: Ann Shah" — the manager the API picked (APM, else PM, else PRM), or "" when there is none. */
export function managerLabel(m: Pick<DirectoryMember, "manager_name" | "manager_no" | "manager_designation">): string {
  const who = m.manager_name || m.manager_no;
  return who ? `${m.manager_designation ? `${m.manager_designation}: ` : ""}${who}` : "";
}
